import React, {useEffect, useState} from 'react'
import {getUserInfo, login as apiLogin} from "../api";
import {callAPI} from "../../../lib/common";
import {suspendResource} from "../../../utils";

const AuthContext = React.createContext()

const getInitialUserInfo = () => {
  const promise = callAPI(`/m/api/user/me`);
  return suspendResource(promise)
}

const initialUser = getInitialUserInfo();

function AuthProvider(props) {
  const userData = initialUser.read();
  const [user, setUser] = useState(() => {
      return userData.isAnonymousUser ? null : userData;
  });
  const [loading, setLoading] = useState(false);

  const getUserInfo = () => {
    return callAPI(`/m/api/user/me`)
      .catch((err) => {

      })
  }

  // Api failed with 401:
  const loggedOut = () => {
    setUser(null);
    setLoading(false);
  }

  const login = (username, password) => {
    return new Promise((resolve, reject) => {
      callAPI('/ajax/login.php', 'POST', {username, password})
        .then(e => {
          if (e.error) {
            reject(e.error)
          }
          else {
            getUserInfo().then((info) => {
              setUser(info)
              resolve()
            })
          }
        }).catch(err => reject(err))
    })
  }

  const signUp = (data) => {
    return new Promise((resolve, reject) => {
      callAPI('/ajax/create.php', 'POST', data)
        .then(e => {
          if (e.error) {
            reject(e);
          }
          else {
            getUserInfo().then((info) => {
              setUser(info)
              resolve()
            })
          }
        }).catch(err => reject(err))
    })
  }

  // make a login request
  const register = () => {} // register the user
  const logout = () => {} // clear the token in localStorage and the user data

  return (
    <AuthContext.Provider value={{loading, user, login, logout, loggedOut, signUp}} {...props} />
  )
}
const useAuth = () => React.useContext(AuthContext)
export {AuthProvider, useAuth}
